import { render, staticRenderFns } from "./PlpProductsList.vue?vue&type=template&id=05ae9a7e&"
import script from "./PlpProductsList.vue?vue&type=script&lang=js&"
export * from "./PlpProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports